import * as ActionType from './action-types';

const initialState = {
  sessionID: '',
  token: '',
  csrfToken: '',
  userInfo: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.getUserInfo:
      return {
        ...state,
        userInfo: action.userInfo
      };
    case ActionType.logout:
      return {
        ...state,
        sessionID: '',
        token: '',
        csrfToken: '',
        userInfo: {}
      };
    case ActionType.setSessionID:
      return {
        ...state,
        sessionID: action.sessionID
      };
    case ActionType.setToken:
      return {
        ...state,
        token: action.token
      };
    case ActionType.setCsrfToken:
      return {
        ...state,
        csrfToken: action.csrfToken
      };
    default:
      return state;
  }
};

export default reducer;
